import { g as t } from "../internals/get-built-in.js";
import { s } from "../internals/set-to-string-tag.js";
var i = "DOMException";
s(t(i), i);